var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardUnavailable({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 5,
    width: 38,
    height: 30,
    rx: 3,
    fill: "#D9D9DA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 11H1V17H39V11Z",
    fill: "#9C9C9C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 24H7.5C6.11929 24 5 25.1193 5 26.5C5 27.8807 6.11929 29 7.5 29H13.5C14.8807 29 16 27.8807 16 26.5C16 25.1193 14.8807 24 13.5 24Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardUnavailable);
export default __webpack_public_path__ + "static/media/card-unavailable.39d4b2aae95970c11ac880b7feedb5a4.svg";
export { ForwardRef as ReactComponent };